"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSessionStorage = void 0;
var _react = require("react");
var _utils = require("../utils");
const getProductKey = () => `persist:${(0, _utils.getRevieveUserId)()}:product`;
const useSessionStorage = ({
  environment,
  partnerId
}) => {
  const advisorKey = `persist:${partnerId}-${environment}`;
  const clear = (0, _react.useCallback)(() => {
    window.sessionStorage.removeItem(advisorKey);
    window.sessionStorage.removeItem(getProductKey());
  }, [advisorKey]);
  const restoreProduct = (0, _react.useCallback)(() => {
    const product = window.sessionStorage.getItem(getProductKey());
    return product ? JSON.parse(product) : undefined;
  }, []);
  const storeProduct = (0, _react.useCallback)(product => window.sessionStorage.setItem(getProductKey(), JSON.stringify(product)), []);
  return (0, _react.useMemo)(() => ({
    clear,
    restoreProduct,
    storeProduct
  }), [clear, restoreProduct, storeProduct]);
};
exports.useSessionStorage = useSessionStorage;